import { render } from "./FormCadSolicitacaoPaciente.vue?vue&type=template&id=4e0e4659&scoped=true"
import script from "./FormCadSolicitacaoPaciente.vue?vue&type=script&lang=js"
export * from "./FormCadSolicitacaoPaciente.vue?vue&type=script&lang=js"

import "./FormCadSolicitacaoPaciente.vue?vue&type=style&index=0&id=4e0e4659&scoped=true&lang=css"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4e0e4659"]])

export default __exports__